module.exports = __webpack_public_path__ + "img/config_carousel_01.753af2be.jpg";